function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "actions/download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stroke",
    d: "M16.33 11.3889L12.165 15M12.165 15L7.99996 11.3889M12.165 15L12.165 2.5M3 17.5V20.1765H21V17.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
SvgDownload.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgDownload"
};
export default SvgDownload;